function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "plug_in"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m17 7h-1v-4c0-.552-.447-1-1-1s-1 .448-1 1v4h-4v-4c0-.552-.447-1-1-1s-1 .448-1 1v4h-1c-.553 0-1 .448-1 1v3c0 2.967 2.167 5.431 5 5.91v4.09c0 .552.447 1 1 1s1-.448 1-1v-4.09c2.833-.479 5-2.942 5-5.91v-3c0-.552-.447-1-1-1zm-1 4c0 2.206-1.794 4-4 4s-4-1.794-4-4v-2h8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13 10h-2c-.553 0-1 .448-1 1s.447 1 1 1h2c.553 0 1-.448 1-1s-.447-1-1-1z"
})));

var Svg092Plugin = function Svg092Plugin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg092Plugin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/092-plugin.a63c68c1.svg";
export { ForwardRef as ReactComponent };